<template>
  <div id="email-url">
    <router-view></router-view>
  </div>

</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main.js'
export default main
</script>
